<template>
  <section>
    <!--工具条-->
    <el-form
      :inline="true"
      v-if="buttonList != null && buttonList.length > 0"
      :model="filters"
      @submit.native.prevent
    >
      <el-form-item label="标题">
        <el-input v-model="filters.Title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.Status" clearable placeholder="请选择状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="启用" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="平台">
        <el-select v-model="filters.Platform" clearable placeholder="请选择平台">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="全部平台" :value="0"></el-option>
          <el-option label="移动端" :value="1"></el-option>
          <el-option label="PC端" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button
          :type="
            item.Func &&
            (item.Func.toLowerCase().indexOf('handledel') != -1 ||
              item.Func.toLowerCase().indexOf('stop') != -1)
              ? 'danger'
              : 'primary'
          "
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column prop="Id" label="ID" width="60"></el-table-column>
      <el-table-column label="图片" width="120">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.ImageUrl"
            :src="scope.row.ImageUrl"
            :preview-src-list="[scope.row.ImageUrl]"
            style="width: 100px; height: 50px"
            fit="cover"
          ></el-image>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="Title" label="标题" width="150"></el-table-column>
      <el-table-column prop="LinkTypeName" label="链接类型" width="100"></el-table-column>
      <el-table-column prop="LinkUrl" label="链接地址" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="PlatformName" label="平台" width="100"></el-table-column>
      <el-table-column prop="Sort" label="排序" width="70"></el-table-column>
      <el-table-column prop="StatusName" label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status === 1 ? 'success' : 'info'" size="small">
            {{ scope.row.StatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="展示时间" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.StartTime || scope.row.EndTime">
            <div v-if="scope.row.StartTime">开始: {{ formatDate(scope.row.StartTime) }}</div>
            <div v-if="scope.row.EndTime">结束: {{ formatDate(scope.row.EndTime) }}</div>
          </div>
          <span v-else>长期有效</span>
        </template>
      </el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" width="160" :formatter="formatCreateTime"></el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!--新增/编辑弹窗-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">
        <el-form-item label="标题" prop="Title">
          <el-input v-model="editForm.Title" placeholder="请输入Banner标题"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="ImageUrl">
          <el-upload
            class="banner-uploader"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
          >
            <img v-if="editForm.ImageUrl" :src="editForm.ImageUrl" class="banner-image" />
            <i v-else class="el-icon-plus banner-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">建议尺寸: 750x320像素，支持jpg/png格式</div>
        </el-form-item>
        <el-form-item label="链接类型" prop="LinkType">
          <el-select v-model="editForm.LinkType" placeholder="请选择链接类型" @change="onLinkTypeChange">
            <el-option label="无链接" :value="0"></el-option>
            <el-option label="内部页面" :value="1"></el-option>
            <el-option label="外部链接" :value="2"></el-option>
            <el-option label="弹框" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接地址" v-if="editForm.LinkType === 1 || editForm.LinkType === 2">
          <el-input v-model="editForm.LinkUrl" placeholder="请输入链接地址"></el-input>
        </el-form-item>
        <!-- 弹框内容 -->
        <template v-if="editForm.LinkType === 3">
          <el-form-item label="弹框标题">
            <el-input v-model="editForm.Popup.Title" placeholder="请输入弹框标题"></el-input>
          </el-form-item>
          <el-form-item label="弹框内容">
            <el-input
              type="textarea"
              :rows="5"
              v-model="editForm.Popup.Content"
              placeholder="请输入弹框内容(支持HTML)"
            ></el-input>
          </el-form-item>
          <el-divider content-position="left">按钮1配置</el-divider>
          <el-form-item label="按钮1文字">
            <el-input v-model="editForm.Popup.ButtonText" placeholder="请输入按钮1文字"></el-input>
          </el-form-item>
          <el-form-item label="按钮1链接">
            <el-input v-model="editForm.Popup.ButtonLink" placeholder="请输入按钮1链接"></el-input>
          </el-form-item>
          <el-form-item label="按钮1颜色">
            <el-color-picker v-model="editForm.Popup.Button1Color"></el-color-picker>
            <span style="margin-left: 10px;">{{ editForm.Popup.Button1Color }}</span>
          </el-form-item>
          <el-divider content-position="left">按钮2配置（可选）</el-divider>
          <el-form-item label="按钮2文字">
            <el-input v-model="editForm.Popup.Button2Text" placeholder="请输入按钮2文字（不填则不显示）"></el-input>
          </el-form-item>
          <el-form-item label="按钮2链接">
            <el-input v-model="editForm.Popup.Button2Link" placeholder="请输入按钮2链接"></el-input>
          </el-form-item>
          <el-form-item label="按钮2颜色">
            <el-color-picker v-model="editForm.Popup.Button2Color"></el-color-picker>
            <span style="margin-left: 10px;">{{ editForm.Popup.Button2Color }}</span>
          </el-form-item>
        </template>
        <!-- 展示平台默认全部平台，隐藏该字段 -->
        <el-form-item label="展示平台" prop="Platform" v-show="false">
          <el-select v-model="editForm.Platform" placeholder="请选择展示平台">
            <el-option label="全部平台" :value="0"></el-option>
            <el-option label="移动端" :value="1"></el-option>
            <el-option label="PC端" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="展示时间">
          <el-date-picker
            v-model="editForm.dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          <div class="upload-tip">不设置则长期有效</div>
        </el-form-item>
        <el-form-item label="排序" prop="Sort">
          <el-input-number v-model="editForm.Sort" :min="0" :max="999"></el-input-number>
          <span class="upload-tip" style="margin-left: 10px">数字越小越靠前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-switch
            v-model="editForm.Status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  BannerGetList,
  BannerGet,
  BannerAdd,
  BannerUpdate,
  BannerDelete,
} from '../../api/api'
import { formatDate } from '../../common/js/date'

export default {
  data() {
    return {
      filters: {
        Title: '',
        Status: -1,
        Platform: -1,
      },
      tableData: [],
      listLoading: false,
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      currentRow: null,
      buttonList: [],

      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      editForm: {
        Id: 0,
        Title: '',
        ImageUrl: '',
        LinkType: 0,
        LinkUrl: '',
        PopupId: null,
        Sort: 0,
        Status: 1,
        Platform: 0,
        dateRange: null,
        Popup: {
          Id: 0,
          Title: '',
          Content: '',
          ButtonText: '',
          ButtonLink: '',
          Button1Color: '#d51900',
          Button2Text: '',
          Button2Link: '',
          Button2Color: '#999999',
        },
      },
      editFormRules: {
        Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        ImageUrl: [{ required: true, message: '请上传图片', trigger: 'change' }],
      },
      uploadUrl: '/images/Upload/Pic',
      uploadHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('Token'),
      },
    }
  },
  created() {
    this.getModules_search()
  },
  methods: {
    callFunc(item) {
      this[item.Func](item)
    },
    // 获取列表
    async getModules_search() {
      this.listLoading = true
      const { data } = await BannerGetList({
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        Title: this.filters.Title,
        Status: this.filters.Status,
        Platform: this.filters.Platform,
      })
      if (data.success) {
        this.tableData = data.response.data
        this.total = data.response.dataCount
        this.buttonList = data.response.buttonList || this.buttonList
        if (this.buttonList.length === 0) {
          this.buttonList = [
            { id: 1, name: '查询', Func: 'getModules_search' },
            { id: 2, name: '新增', Func: 'handleAdd' },
            { id: 3, name: '编辑', Func: 'handleEdit' },
            { id: 4, name: '删除', Func: 'handleDel' },
          ]
        }
      }
      this.listLoading = false
    },
    // 选中行
    selectCurrentRow(row) {
      this.currentRow = row
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getModules_search()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getModules_search()
    },
    // 新增
    handleAdd() {
      this.dialogTitle = '新增Banner'
      this.resetForm()
      this.dialogVisible = true
    },
    // 编辑
    async handleEdit() {
      if (!this.currentRow) {
        this.$message.warning('请选择要编辑的记录')
        return
      }
      this.dialogTitle = '编辑Banner'
      const { data } = await BannerGet({ id: this.currentRow.Id })
      if (data.success && data.response) {
        const item = data.response
        this.editForm = {
          Id: item.Id,
          Title: item.Title,
          ImageUrl: item.ImageUrl,
          LinkType: item.LinkType,
          LinkUrl: item.LinkUrl,
          PopupId: item.PopupId,
          Sort: item.Sort,
          Status: item.Status,
          Platform: item.Platform,
          dateRange: item.StartTime && item.EndTime ? [item.StartTime, item.EndTime] : null,
          Popup: item.Popup || {
            Id: 0,
            Title: '',
            Content: '',
            ButtonText: '',
            ButtonLink: '',
            Button1Color: '#d51900',
            Button2Text: '',
            Button2Link: '',
            Button2Color: '#999999',
          },
        }
        // 确保Popup中的颜色字段有默认值
        if (this.editForm.Popup) {
          if (!this.editForm.Popup.Button1Color) {
            this.editForm.Popup.Button1Color = '#d51900'
          }
          if (!this.editForm.Popup.Button2Color) {
            this.editForm.Popup.Button2Color = '#999999'
          }
        }
        this.dialogVisible = true
      }
    },
    // 删除
    async handleDel() {
      if (!this.currentRow) {
        this.$message.warning('请选择要删除的记录')
        return
      }
      this.$confirm('确认删除该Banner吗?', '提示', {
        type: 'warning',
      }).then(async () => {
        const { data } = await BannerDelete({ id: this.currentRow.Id })
        if (data.success) {
          this.$message.success('删除成功')
          this.getModules_search()
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 重置表单
    resetForm() {
      this.editForm = {
        Id: 0,
        Title: '',
        ImageUrl: '',
        LinkType: 0,
        LinkUrl: '',
        PopupId: null,
        Sort: 0,
        Status: 1,
        Platform: 0,
        dateRange: null,
        Popup: {
          Id: 0,
          Title: '',
          Content: '',
          ButtonText: '',
          ButtonLink: '',
          Button1Color: '#d51900',
          Button2Text: '',
          Button2Link: '',
          Button2Color: '#999999',
        },
      }
    },
    // 链接类型变化
    onLinkTypeChange(val) {
      if (val !== 3) {
        this.editForm.Popup = {
          Id: 0,
          Title: '',
          Content: '',
          ButtonText: '',
          ButtonLink: '',
          Button1Color: '#d51900',
          Button2Text: '',
          Button2Link: '',
          Button2Color: '#999999',
        }
      }
    },
    // 图片上传成功
    handleUploadSuccess(res) {
      if (res.success) {
        // 拼接OSS域名前缀
        const ossBaseUrl = 'https://share.51i.cc/'
        this.editForm.ImageUrl = ossBaseUrl + res.response
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },
    // 上传前校验
    beforeUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('只能上传JPG/PNG格式图片')
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB')
      }
      return isImage && isLt2M
    },
    // 提交表单
    submitForm() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          const params = {
            ...this.editForm,
            StartTime: this.editForm.dateRange ? this.editForm.dateRange[0] : null,
            EndTime: this.editForm.dateRange ? this.editForm.dateRange[1] : null,
          }
          let res
          if (this.editForm.Id > 0) {
            res = await BannerUpdate(params)
          } else {
            res = await BannerAdd(params)
          }
          this.submitLoading = false
          if (res.data.success) {
            this.$message.success(this.editForm.Id > 0 ? '编辑成功' : '新增成功')
            this.dialogVisible = false
            this.getModules_search()
          } else {
            this.$message.error(res.data.msg)
          }
        }
      })
    },
    // 格式化日期
    formatDate(date) {
      if (!date) return ''
      return formatDate(new Date(date), 'yyyy-MM-dd hh:mm')
    },
    formatCreateTime(row) {
      if (!row.CreateTime) return ''
      return formatDate(new Date(row.CreateTime), 'yyyy-MM-dd hh:mm')
    },
  },
}
</script>

<style scoped>
.banner-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 300px;
  height: 130px;
}
.banner-uploader:hover {
  border-color: #409eff;
}
.banner-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}
.banner-image {
  width: 300px;
  height: 130px;
  display: block;
  object-fit: cover;
}
.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}
</style>
